import React from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import { SeeCmsIconTooltip } from '../SeeIconTooltip'
import { DEFAULT_AQUASYS_SUPPORT_EMAIL } from 'components/sieau/SieauConstants'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import cmsSupportHelp from 'assets/pictures/observatory/cmsSupportHelp.webp'
import supportContactScheduleHelp from 'assets/pictures/observatory/supportContactScheduleHelp.webp'
import supportPhoneNumberHelp from 'assets/pictures/observatory/supportPhoneNumberHelp.webp'
import supportMailAddressHelp from 'assets/pictures/observatory/supportMailAddressHelp.webp'

const SupportPanelParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => (
    <ParameterCard title={i18n.supportPanel} isGlobal={isGlobal}>
        <ParameterWithSuperMultiAutocomplete
            {...defaultProps}
            parameter='cmsSupport'
            title={i18n.articleSubtitleSupportPanelCMS}
            helpImage={cmsSupportHelp}
            iconTooltip={<SeeCmsIconTooltip />}
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='supportContactSchedule'
            title={i18n.supportOpeningDays}
            helpImage={supportContactScheduleHelp}
            placeholder={i18n.mondayThroughFriday}
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='supportPhoneNumber'
            title={i18n.supportPhoneNumber}
            helpImage={supportPhoneNumberHelp}
            placeholder='09 51 72 41 72'
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='supportMailAddress'
            title={i18n.supportEMailAddress}
            helpImage={supportMailAddressHelp}
            placeholder={DEFAULT_AQUASYS_SUPPORT_EMAIL}
        />
    </ParameterCard>
)

SupportPanelParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default SupportPanelParameters
